module.exports = __webpack_public_path__ + "media/images/brands/marque-ciate@2x-f9c48f4ac5b904451cbda997c2b116ce.jpg";